// extracted by mini-css-extract-plugin
export default {"wrapper":"feedback-button-box_wrapper__o8eXu"};